import { isInAppBrowser } from 'commons/utils/isInAppBrowser';

export function useIsInAppBrowser() {
  const isInAppBrowserOpen = isInAppBrowser();
  return isInAppBrowserOpen;
}
